"use client";
import {
  Label
} from "./chunk-AYNBFKBK.js";

// src/form.tsx
import { cn } from "@momo/utils";
import { Slot } from "@radix-ui/react-slot";
import { createContext, useContext, useId, useMemo } from "react";
import {
  Controller,
  FormProvider,
  useFormContext
} from "react-hook-form";
import { jsx } from "react/jsx-runtime";
var Form = FormProvider;
var FormFieldContext = createContext(void 0);
var FormItemContext = createContext(void 0);
var FormField = (props) => {
  const { name } = props;
  const context = useMemo(() => ({ name }), [name]);
  return /* @__PURE__ */ jsx(FormFieldContext, { value: context, children: /* @__PURE__ */ jsx(Controller, { ...props }) });
};
var useFormField = () => {
  const fieldContext = useContext(FormFieldContext);
  const itemContext = useContext(FormItemContext);
  const { getFieldState, formState } = useFormContext();
  if (!fieldContext || !itemContext) {
    throw new Error("useFormField must be used within a FormField and FormItem");
  }
  const fieldState = getFieldState(fieldContext.name, formState);
  const { id } = itemContext;
  return {
    id,
    name: fieldContext.name,
    formItemId: `${id}-form-item`,
    formDescriptionId: `${id}-form-item-description`,
    formMessageId: `${id}-form-item-message`,
    ...fieldState
  };
};
var FormItem = (props) => {
  const { className, ...rest } = props;
  const id = useId();
  const context = useMemo(() => ({ id }), [id]);
  return /* @__PURE__ */ jsx(FormItemContext, { value: context, children: /* @__PURE__ */ jsx("div", { className: cn("space-y-2", className), ...rest }) });
};
var FormLabel = (props) => {
  const { className, ...rest } = props;
  const { error, formItemId } = useFormField();
  return /* @__PURE__ */ jsx(Label, { className: cn(error && "text-destructive", className), htmlFor: formItemId, ...rest });
};
var FormControl = (props) => {
  const { error, formItemId, formDescriptionId, formMessageId } = useFormField();
  return /* @__PURE__ */ jsx(
    Slot,
    {
      id: formItemId,
      "aria-describedby": error ? `${formDescriptionId} ${formMessageId}` : formDescriptionId,
      "aria-invalid": !!error,
      ...props
    }
  );
};
var FormDescription = (props) => {
  const { className, ...rest } = props;
  const { formDescriptionId } = useFormField();
  return /* @__PURE__ */ jsx(
    "p",
    {
      id: formDescriptionId,
      className: cn("text-muted-foreground text-sm", className),
      ...rest
    }
  );
};
var FormMessage = (props) => {
  const { className, children, ...rest } = props;
  const { error, formMessageId } = useFormField();
  const body = error ? String(error.message) : children;
  if (!body) return null;
  return /* @__PURE__ */ jsx(
    "p",
    {
      id: formMessageId,
      className: cn("text-destructive text-sm font-medium", className),
      ...rest,
      children: body
    }
  );
};

export {
  Form,
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormDescription,
  FormMessage
};
